<template>
  <div class="container py-3">
    <div class="jumbotron py-3 shadow-sm">
      <h1>FAQ</h1>
        <ul>
          <li
            v-for="item in faqitems"
            :key="item.id"
            v-on:click="hightlightIndex = item.id">
            <a :href="'#' + item.id">{{ item.title }}</a>
          </li>
        </ul>
        <div
          v-for="item in faqitems"
          :key="item.id"
          v-bind:class="{active: hightlightIndex === item.id}"
          class="p-1">
          <h3 :id="item.id" class="mt-2 pb-1" >{{ item.title }}</h3>
          <template v-for="msg in item.msgs">
            <p :key="msg"><span v-html="msg"></span></p>
          </template>
          </div>
    </div>
  </div>
</template>

<script>
// edit faq.json to update the FAQ content
import faqJson from './faq.json'

export default {
  name: 'FAQ',
  data () {
    return {
      faqitems: faqJson,
      hightlightIndex: null,
    }
  },
  mounted: function () {
    var v = this;
    if(this.$route.hash){
      var target = this.$route.hash.slice(1);
      v.hightlightIndex = target;
    }
  }
}
</script>

<style scoped>

.active {
  background-color: #f3f6fa;
  border-radius: 5px;
}

::v-deep a {
  color: #0665CB;
}

::v-deep code {
  color: #BB3473;
}

::v-deep p a {
  text-decoration: underline;
}

</style>
